import nx from '@jswork/next';

const dlgConfig = {
  total: { min: 40, max: 160 },
  listening: { min: 10, max: 160 },
  reading: { min: 10, max: 160 },
  writing: { min: 10, max: 160 },
  speaking: { min: 10, max: 160 },
};

const defaults = {
  toefl: {
    total: { min: 0, max: 120 },
    listening: { min: 0, max: 30 },
    reading: { min: 0, max: 30 },
    writing: { min: 0, max: 30 },
    speaking: { min: 0, max: 30 },
  },
  ielts: {
    total: { min: 4, max: 9 },
    listening: { min: 4, max: 9 },
    reading: { min: 4, max: 9 },
    writing: { min: 4, max: 9 },
    speaking: { min: 4, max: 9 },
  },
  gre: {
    total: { min: 260, max: 340 },
    verbal: { min: 130, max: 170 },
    quantitative: { min: 130, max: 170 },
  },
  gmat: {
    total: { min: 205, max: 805 },
    verbal: { min: 60, max: 90 },
    quant: { min: 60, max: 90 },
    data_insights: { min: 60, max: 90 },
  },
  pte: {
    total: { min: 20, max: 90 },
    listening: { min: 20, max: 90 },
    reading: { min: 20, max: 90 },
    writing: { min: 20, max: 90 },
    speaking: { min: 20, max: 90 },
  },
  duolingo: dlgConfig,
  // 冗余兼容设计
  duolingo_english_test: dlgConfig,
};

export default (type: string, field: string) => {
  return nx.get(defaults, `${type}.${field}`);
}
